import { useTheme } from "../../theme/useTheme"
import { Deemphasize } from "../ui/CustomTypography"
import { Box, Typography } from "@mui/material"

interface TimeLocationContainerProps {
    location: string
    startTime: Date
    endTime: Date | "present"
    formatDate: (date: Date) => string
}

export const TimeLocationContainer = ({
    location,
    startTime,
    endTime,
    formatDate,
}: TimeLocationContainerProps) => {
    const { breakpoints, audience } = useTheme()

    return (
        <Box
            sx={{
                textAlign: breakpoints.isFullPage ? "right" : "left",
                marginLeft: breakpoints.isFullPage ? "auto" : 0,
                display: "flex",
                alignItems: "end",
                justifyContent: breakpoints.isFullPage ? "flex-end" : "flex-start",
            }}
            data-testid="time-container"
        >
            <Typography variant="body1" sx={{ marginBottom: 0 }}>
                {audience.mode === "international" ? (
                    <>
                        {location}
                        {/* same treatment as the certificate separators: a
                            full-size solid dot next to real text reads as
                            content, not punctuation */}
                        <Deemphasize>{" • "}</Deemphasize>{" "}
                    </>
                ) : null}
                {formatDate(startTime)} - {endTime === "present" ? "Present" : formatDate(endTime)}
            </Typography>
        </Box>
    )
}
